import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/helper/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { IShopFilter } from "./shopModel";

export const getALlProductForWeb = createAsyncThunk(
  "Shop/GetALlProductForWeb",
  async (filters: IShopFilter) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Product/GetALlProductForWeb`,
        filters,
      );
      return response.data;
    } catch (error: any) {
      console.error("Error Fetching Shop Products:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const getCostToCostProductForWeb = createAsyncThunk(
  "Shop/GetCostToCostProductForWeb",
  async (filters: IShopFilter) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Product/CostToCostProductForWeb`,
        { ...filters, IsCostToCost: true },
      );
      return response.data;
    } catch (error: any) {
      console.error("Error Fetching CostToCost Products:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const getOtherProductForWeb = createAsyncThunk(
  "Shop/GetOtherProductForWeb",
  async (filters: IShopFilter) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Product/CostToCostProductForWeb`,
        { ...filters, IsCostToCost: false },
      );
      return response.data;
    } catch (error: any) {
      console.error("Error Fetching Other Products:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
